import { IF360Validator } from "./F360Validator";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { inject, injectable } from "inversify";

@injectable()
export default class CadisValidator implements IF360Validator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  handleValidation(): boolean {
    const codigoCliente =
      this.userProfileMixin.handleGetUserProfile()?.CodigoCliente;
    const isCadis = codigoCliente?.includes("CDS") || false;

    return isCadis;
  }
}
